var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.claims.upcomingEvent.read)?_c('panel',{attrs:{"panel":this.panel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }